// frontend/AppWrapper.tsx
import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { Provider } from 'react-redux';
import store from './store/store';
import ThemeSwitcher from './ThemeSwitcher';

const AppWrapper: React.FC = () => {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
    >
      <Provider store={store}>
        <ThemeSwitcher />
      </Provider>
    </Auth0Provider>
  );
};

export default AppWrapper;